(function () {
  function berlinNow() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' }));
  }
  function startOfDay(d) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }
  function addCalendarDays(d, n) {
    var x = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    x.setDate(x.getDate() + n);
    return x;
  }
  function nextBusinessDay(d) {
    var x = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    while (x.getDay() === 0 || x.getDay() === 6) x.setDate(x.getDate() + 1);
    return x;
  }
  function addBusinessDays(start, n) {
    var x = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    var added = 0;
    while (added < n) {
      x.setDate(x.getDate() + 1);
      if (x.getDay() !== 0 && x.getDay() !== 6) added++;
    }
    return x;
  }
  function fmtDE(d) {
    return d.getDate() + '. ' + d.toLocaleDateString('de-DE', { month: 'long' });
  }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function render(root) {
    var cutoffH = parseInt(root.getAttribute('data-cutoff-h') || '23', 10);
    var cutoffM = parseInt(root.getAttribute('data-cutoff-m') || '59', 10);
    var shipOffset = parseInt(root.getAttribute('data-ship-offset') || '1', 10);
    var delivMin = parseInt(root.getAttribute('data-deliv-min') || '3', 10);
    var delivMax = parseInt(root.getAttribute('data-deliv-max') || '5', 10);
    var tpl = root.getAttribute('data-countdown-tpl') || 'Wenn Du innerhalb [time] bestellst';

    var now = berlinNow();
    var cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoffH, cutoffM, 0, 0);
    if (now > cutoff) cutoff = addCalendarDays(cutoff, 1);

    var ms = cutoff - now;
    var hrs = Math.floor(ms / 3600000);
    var mins = Math.floor((ms % 3600000) / 60000);
    var timeStr = hrs + ' Std. ' + mins + ' Min.';
    var countdownEl = root.querySelector('[data-vm-dt-countdown]');
    if (countdownEl) {
      var html = tpl.replace(/\{\{\s*time\s*\}\}|\[time\]/g, '<span data-vm-dt-time>' + timeStr + '</span>');
      // wrap time in accent span if not already
      countdownEl.innerHTML = html;
      var t = countdownEl.querySelector('[data-vm-dt-time]');
      if (t) t.textContent = timeStr;
    }

    // Shipping date: today + shipOffset, skip weekend → Monday
    var ship = addCalendarDays(startOfDay(now), shipOffset);
    ship = nextBusinessDay(ship);
    var delivFrom = addBusinessDays(ship, delivMin);
    var delivTo = addBusinessDays(ship, delivMax);

    var shipEl = root.querySelector('[data-vm-dt-shipped]');
    var delivEl = root.querySelector('[data-vm-dt-delivered]');
    if (shipEl) shipEl.textContent = fmtDE(ship);
    if (delivEl) delivEl.textContent = fmtDE(delivFrom) + ' – ' + fmtDE(delivTo);
  }

  function boot() {
    document.querySelectorAll('[data-vm-dtimeline]').forEach(function (el) {
      render(el);
      if (!el._vmDtTimer) {
        el._vmDtTimer = setInterval(function () { render(el); }, 30000);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
